import React, {useContext, useEffect, useState} from "react";
import {TrafficLightDeviceOverviewContext} from "./context/TrafficLightOverviewContext";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Select, {SelectOption} from "@amzn/meridian/select";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import TrafficLightControlPage from "./TrafficLightControlPage";

const TrafficLightControllerSelectPage = () => {
    const {viewModel, dispatch} = useContext(TrafficLightDeviceOverviewContext);
    const [deviceConfigs, setDeviceConfigs] = useState([]);
    const [filteredDeviceConfig, setFilteredDeviceConfig] = useState({})
    const [selectedMac, setSelectedMac] = useState("")
    const [indexForControllerData, setIndexForControllerData] = useState(null);

    const fetchDeviceInformation = () => {
        dispatch({type: 'LOAD_DATA', data: {dispatcher: dispatch}});
    }

    const changeSelectedMac = (value) => {
        setSelectedMac(value)
        let selectedDeviceConfig = {}
        deviceConfigs.forEach((device, index) => {
            if(device.assetAttributes.mac === value) {
                selectedDeviceConfig = {...device}
                setIndexForControllerData(index)
                setFilteredDeviceConfig(selectedDeviceConfig);
                return;
            }
        })
    }

    useEffect(() => {
        if(!viewModel.deviceInformation.assetDetails) {
            fetchDeviceInformation();
        } else {
            const newDeviceInformation = JSON.parse(JSON.stringify(viewModel.deviceInformation.assetDetails));
            setDeviceConfigs(newDeviceInformation)
        }
    },[viewModel.deviceInformation.assetDetails])

    return (
        <Column>
            <Box type="fill" spacingInset="medium">
                <Row alignmentHorizontal="justify" widths={["fill", '30%']} spacing="400">
                    <Row>
                        <Text>
                            <FormattedMessage id="devicename.title" defaultMessage="Select Device"/>
                        </Text>
                        <Select
                            value={selectedMac}
                            onChange={changeSelectedMac}
                            placeholder={"Select Device"}
                            size="small"
                            width={250}>
                            {deviceConfigs.map((device) => (
                                <SelectOption key={device.assetAttributes.mac} value={device.assetAttributes.mac}
                                              label={device.assetAttributes.name + " (" + device.assetAttributes.mac + ")"}/>
                            ))}
                            {!deviceConfigs.length &&
                                <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                    <Text alignment="center"> No devices available </Text>
                                </Column>
                            }
                        </Select>
                    </Row>
                </Row>
            </Box>
            <Box>
                <TrafficLightControlPage controllerDetails={filteredDeviceConfig} indexForControllerData={indexForControllerData}/>
            </Box>
        </Column>
    )
}

export default  TrafficLightControllerSelectPage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/TrafficLightControllerSelectPage.js